<template>
  <Card>
    <h1 slot="Title">States of Appropriation</h1>
    <div slot="MainContent">
      <p>
        The fiscal year plus the appropriation determines the state of an appropriation.
      </p>
      <p class="ma-0">
        <b>
          There are three states of an appropriation:
        </b>
      </p>
      <ol>
        <li>
          Unexpired
        </li>
        <li>
          Expired
        </li>
        <li>
          Closed
        </li>
      </ol>
    </div>
    <div slot="Notes">
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">States of an Appropriation</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">REF: 37-100&gt;22-FY- 2 &amp; 3</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">Some appropriations are for only one year (Operation Maintenance, Army (OMA), Operation Maintenance, Army Reserve (OMAR), Military Personnel, Army (MPA), and Operation Maintenance, Army Reserve National Guard (OMARNG)). &nbsp;Other appropriations are for longer periods (Research, Development, Test, and Evaluation (RDTE) 2 years, Military Construction Army (MCA) 5 years), and still others are for indefinite periods (Army Working Capital Fund (AWCF) X years). &nbsp;The fiscal year plus the basic symbol determines the&nbsp;</span><u><span style="font-size: 16px; font-family: Calibri;">State of an Appropriation</span></u><span style="font-size: 16px; font-family: Calibri;">, Unexpired, Expired, or Closed.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">Terms:</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">Beginning Fiscal Year (BGFY) - The first fiscal year for which a code is valid.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">&nbsp;</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri;">Termination Fiscal Year (TMFY) - The last fiscal year for which a code is valid (or the fiscal year in which the use of a code is &quot;terminated&quot; (inactivated)).</span></span></p>
    </div>
  </Card>
</template>

<style scoped>
  ol {
    padding-left: 20px;
  }
  ol > li {
    padding: 0;
    margin: 0;
  }
</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriation',
  
  data() {
    return {
    }
  }
  
}
</script>